// components/plScenario/table/EditableCell.jsx
import React from 'react';

const EditableCell = ({
  value,
  isEditing,
  isActual,
  isEdited,
  className = '',
  onEdit,
  onSave,
  onCancel,
  onChange,
  formatValue,
}) => {
  if (isEditing) {
    return (
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onSave}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSave();
          if (e.key === 'Escape') onCancel();
        }}
        autoFocus
        className="w-full px-1 text-center border border-blue-500 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
      />
    );
  }

  return (
    <div 
      className={`flex items-center justify-center gap-1 ${!isActual ? 'cursor-pointer' : ''}`}
      onClick={!isActual ? onEdit : undefined}
    >
      {formatValue(value)}
      {isEdited && (
        <span className="inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold text-amber-700 bg-amber-200 rounded-full border border-amber-400">
          ✓
        </span>
      )}
    </div>
  );
};

export default EditableCell;